import { render } from "./InviteContractCompany.vue?vue&type=template&id=7185665c"
import script from "./InviteContractCompany.vue?vue&type=script&lang=js"
export * from "./InviteContractCompany.vue?vue&type=script&lang=js"

import "./InviteContractCompany.vue?vue&type=style&index=0&id=7185665c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__